import React, { useState } from "react";
import SoftEstimateLogo from './SoftEstimateLogo';
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import RefundPolicy from "./RefundPolicy";

const Layout = ({ children }) => {
    const [isTermsOpen, setIsTermsOpen] = useState(false);
    const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
    const [isRefundOpen, setIsRefundOpen] = useState(false);
    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header - Reduced Padding */}
            <header className="w-full bg-white shadow-sm py-3 flex justify-center">
                {/* <a href="https://SoftTelRG.com" target="_blank" rel="noopener noreferrer">
                    <img 
                        src={`${process.env.PUBLIC_URL}/images/SoftTelRG-nbg.png`} 
                        alt="SoftTelRG Logo" 
                        className="max-w-full h-auto max-h-16 md:max-h-20 lg:max-h-24"
                    />
                </a> */}
                <SoftEstimateLogo />
            </header>

            {/* Main Content - Slimmer Padding & No Flex Grow */}
            <main className="w-full flex justify-center px-4 md:px-8 lg:px-12">
                <div className="w-full max-w-5xl py-4 md:py-6 lg:py-8">
                    {children}
                </div>
            </main>

            {/* Footer - Reduced Padding */}
            <footer className="w-full bg-white text-center py-3 text-gray-600 border-t">
                <div>
                    <div><p>
                    <strong><span className="text-green-600">Soft</span><span className="text-blue-600">Estimate</span></strong> is a proprietary estimation tool developed and managed by{" "}
                        {/* <a
                            href="https://softtelrg.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            SoftTelRG
                        </a>. */}

                        <strong><span className="text-green-600">Soft</span><span className="text-blue-600">Tel</span><span className="text-green-600">R</span><span className="text-blue-600">G</span></strong>
                    </p>
                        <p>© {new Date().getFullYear()}{" "} <strong><span className="text-green-600">Soft</span><span className="text-blue-600">Tel</span><span className="text-green-600">R</span><span className="text-blue-600">G</span></strong> All rights reserved</p></div>
                    <div className="space-x-4">
                        <button
                            onClick={() => setIsTermsOpen(true)}
                            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded">
                            Terms of Service
                        </button>

                        <button
                            onClick={() => setIsPrivacyOpen(true)}
                            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded">
                            Privacy Policy
                        </button>

                        <button
                            onClick={() => setIsRefundOpen(true)}
                            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded">
                            Refund Policy
                        </button>
                        <button
                            onClick={() => window.open("https://billing.stripe.com/p/login/eVa17Ff248zAcj64gg", "_blank")}
                            className="text-black underline hover:bg-gray-200 transition bg-transparent border-none px-2 py-1 rounded"
                        >
                            Subscription
                        </button>



                    </div>

                    {/* Popup Modals */}
                    <TermsOfService isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
                    <PrivacyPolicy isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
                    <RefundPolicy isOpen={isRefundOpen} onClose={() => setIsRefundOpen(false)} />
                </div>
            </footer>
        </div>
    );
};

export default Layout;
